//@flow
import * as Immutable from 'immutable';

import {
    TeamSettingsResponse,
    TeamSettingsRequest,
    TeamSettings
} from 'platform/settings/models/flow/TeamSettings';

import type {
    TeamSettingsResponseModelType,
    TeamSettingsRequestModelType,
    TeamSettingsModelType
} from 'platform/settings/models/flow/TeamSettings';

import { VAEConfiguration } from 'platform/settings/models/internal/ClientSettings';

class InternalTeamSettingsResponse extends TeamSettingsResponse {
    static fromJS(
        json: TeamSettingsResponseModelType
    ): InternalTeamSettingsResponse {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalTeamSettingsRequest extends TeamSettingsRequest {
    static fromJS(
        json: TeamSettingsRequestModelType
    ): InternalTeamSettingsRequest {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalTeamSettings extends TeamSettings {
    static fromJS(json: TeamSettingsModelType): InternalTeamSettings {
        const state: Object = Object.assign({}, json);
        state.vaeConfiguration = state.vaeConfiguration
            ? VAEConfiguration.fromJS(state.vaeConfiguration)
            : state.vaeConfiguration;
        return new this(Immutable.Map(state));
    }
}

export {
    InternalTeamSettingsResponse as TeamSettingsResponse,
    InternalTeamSettingsRequest as TeamSettingsRequest,
    InternalTeamSettings as TeamSettings
};
